<div class="font-awesome-finder">
  <div class="icons-header">
    <div class="row">
      <div class="col-6">
        <lib-gung-text-input
          gungTranslate="{{ 'SEARCH' | translate }}"
          [extraInputClass]="'form-control-sm'"
          [placeholder]="'SEARCH' | translate"
          [(ngModel)]="search"
          (ngModelChange)="searchIcons($event)"
        ></lib-gung-text-input>
      </div>
      <div class="col-6 d-flex">
        <div class="form-group">
          <label for="font-awesome-copy">
            {{ 'COPY' | translate }}
            <a href="https://fontawesome.com/v6/search" target="_blank">fontawesome.com</a>
          </label>
          <input
            type="text"
            [ngClass]="'form-control form-control-sm'"
            id="font-awesome-copy"
            placeholder="<i class='fab fa-icon'></i>"
            [(ngModel)]="fontawesomeValue"
            (ngModelChange)="fontawesomeChange($event)"
          />
        </div>
        @if (fontawesomeIconClasses) {
          <div class="fw-icon" (click)="pickFontawesomeIcon()">
            <i class="{{ fontawesomeIconClasses }}"></i>
          </div>
        }
        <!-- <lib-gung-text-input
          gungTranslate="{{ 'FONT_AWOSEME_COPY' | translate }}"
          [extraInputClass]="'form-control-sm'"
          placeholder="<i class='fab fa-icon'></i>"
          [(ngModel)]="search"
          (ngModelChange)="searchIcons($event)"
        ></lib-gung-text-input> -->
      </div>
    </div>

    <div class="d-flex mt-2">
      <div class="prefix" [class.bg-primary]="prefix === 'fas'" (click)="prefix = 'fas'" translate>SOLID</div>
      <div class="prefix" [class.bg-primary]="prefix === 'fa-regular'" (click)="prefix = 'fa-regular'" translate>
        REGULAR
      </div>
      <div class="prefix" [class.bg-primary]="prefix === 'fa-thin'" (click)="prefix = 'fa-thin'" translate>THIN</div>
      <div class="prefix" [class.bg-primary]="prefix === 'fa-brands'" (click)="prefix = 'fa-brands'" translate>
        BRANDS
      </div>
    </div>
  </div>
  @if (icons && icons.length > 0) {
    <div class="icons-body" [ngStyle]="{ 'height.px': height }">
      <div class="grid mt-2">
        <div class="icon-item text-center" *ngFor="let icon of filterIcons" (click)="pickIcon(icon)">
          <i [ngClass]="prefix + ' fa-' + icon"></i>
          <div class="text-center icon-text">{{ icon }}</div>
        </div>
      </div>
    </div>
  }
</div>
